<template>
  <span>
    <v-dialog max-width="1000px" persistent :value="true">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("global.insurance") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <multiple-user-select :birth-date-required="true" />
            <v-row dense>
              <v-col cols="12">
                <location-ajax-select
                  :label="$t('travelService.place') + '*'"
                  :placeholder="$t('travelService.enterCountry')"
                  :rules="[v => (v != null && v.length > 0) || $t('global.error.required')]"
                  :select-model.sync="contextModel.travelServiceOrderItemInsurance.place_id"
              /></v-col>
            </v-row>
            <v-row dense>
              <v-col class="pr-2" cols="6">
                <date-picker
                  :label="$t('global.startDate') + '*'"
                  :max="contextModel.travelServiceOrderItemInsurance.end_date"
                  :model.sync="contextModel.travelServiceOrderItemInsurance.start_date"
                  :rules="[validatorIsRequired, validatorIsFutureDate]"
                />
              </v-col>
              <v-col class="pl-2" cols="6">
                <date-picker
                  :label="$t('global.endDate') + '*'"
                  :min="contextModel.travelServiceOrderItemInsurance.start_date"
                  :model.sync="contextModel.travelServiceOrderItemInsurance.end_date"
                  :rules="[validatorIsRequired, validatorIsFutureDate]"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6">
                <cost-centre-select :value.sync="contextModel.cost_centre" />
              </v-col>
            </v-row>

            <v-text-field :label="$t('global.comment')" v-model="contextModel.comment" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="cancel" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid" @click.native="save" color="blue darken-1" text>Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import LocationAjaxSelect from "../CustomInputComponents/LocationAjaxSelect";
import DatePicker from "../CustomInputComponents/DatePicker";
import MultipleUserSelect from "./MultipleUserSelect";
import CostCentreSelect from "./CostCentreSelect";
import vue from "../../main";
import moment from "moment";

export default {
  name: "OrderServiceInsuranceDialog",
  components: {
    CostCentreSelect,
    MultipleUserSelect,
    DatePicker,
    LocationAjaxSelect
  },
  data: () => ({
    formValid: true,
    contextModel: null
  }),
  computed: {
    editedTravelServiceOrderItem() {
      return this.$store.state.TravelService.editedTravelServiceItem;
    }
  },
  watch: {
    contextModel: {
      deep: true,
      handler() {
        if (JSON.stringify(this.contextModel) !== JSON.stringify(this.editedTravelServiceOrderItem)) {
          this.updateVuexState();
        }
      }
    },
    editedTravelServiceOrderItem: {
      deep: true,
      handler(val) {
        this.contextModel = JSON.parse(JSON.stringify(val));
      }
    }
  },
  methods: {
    validatorIsRequired(v) {
      return (v != null && v.length > 0) || this.$t("global.error.required");
    },
    validatorIsFutureDate(v) {
      return (
        moment(v)
          .endOf("day")
          .isAfter(moment()) || vue.$t("global.error.dateLaterThanNow")
      );
    },
    updateVuexState() {
      this.$store.commit("TravelService/setEditedTravelServiceItem", this.contextModel);
    },
    cancel() {
      this.$store.commit("TravelService/setEditedTravelServiceItem", null);
      this.$store.commit("TravelService/setOldTravelServiceItem", null);
      this.$refs.form.resetValidation();
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("TravelService/saveEditedServiceItem");
      }
    }
  },
  created() {
    //this.contextModel.is_insurance = parseInt(this.$store.getters["userProperties"].system_settings.travel_service_hotel_insurance) === 1;
    this.contextModel = JSON.parse(JSON.stringify(this.editedTravelServiceOrderItem));
  }
};
</script>

<style scoped></style>
